import { useState } from "react";
import { BusinessCard } from "./BusinessCard";
import { InspirationModal } from "./InspirationModal";
import { BuildModal } from "./BuildModal";
import { usePro } from "../hooks/usePro";

export const BusinessGrid = ({ businesses }) => {
  const [selected, setSelected] = useState(null);
  const [building, setBuilding] = useState(null);
  const { attempt } = usePro();

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="business-grid">
        {businesses.map((b, i) => (
          <BusinessCard key={b.id} business={b} index={i} onInspire={setSelected} />
        ))}
      </div>
      <InspirationModal
        business={selected}
        onClose={() => setSelected(null)}
        onBuild={(b) => setBuilding(b)}
      />
      <BuildModal business={building} onClose={() => setBuilding(null)} />
    </>
  );
};
